/* eslint-disable */
export default {
  install (Vue, options) {
    // TODO: rename function
    // https://vuejs.org/v2/style-guide/#Private-property-names-essential
    Vue.prototype.$prefixCss = function () {
      return `${options.prefix}-`
    }
  },
}
